import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeBinding = this.close.bind(this)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    // Use a small timeout to avoid the click that opened the menu from immediately closing it
    setTimeout(() => {
      window.addEventListener("click", this.closeBinding)
    }, 1)
  }

  close(event) {
    if (event && (this.element.contains(event.target))) {
      return
    }
    this.menuTarget.classList.add("hidden")
    window.removeEventListener("click", this.closeBinding)
  }

  disconnect() {
    window.removeEventListener("click", this.closeBinding)
  }
}
